import React from "react";

const GameTracker = ({ fixtureId, productName, layout = "standard" }) => {
  const iframeUrl = `https://gsm-widgets-uat.betstream.betgenius.com/multisportgametracker?fixtureId=${fixtureId}&productName=${productName}&layout=${layout}`;

  return (
    <div style={{ width: "100%", minHeight: "400px" }}>
      <iframe
        src={iframeUrl}
        width="100%"
        height="450"
        style={{ border: "none", minWidth: "300px", minHeight: "350px" }}
        allowFullScreen
        title="Game Tracker"
      ></iframe>
    </div>
  );
};

export default GameTracker;
